import axios from 'axios'
import { Message } from 'element-ui'
import Qs from 'qs'
//import store from '../store/index'
/*
*请求失败后的错误统一处理
*
*
*/

const errorMsg = (status, other) => {
    //状态码判断
    switch (status) {
        case 400:
            Message.error(other?.msg || '未知错误');
            break;
        case 401:
            Message({
                type: 'error',
                duration: 5000,
                offset: 50,
                dangerouslyUseHTMLString: true,
                message: "接口调用失败，原因：登录失效！！！<a style='color:blue' onclick='returnLogin()' >去登录</a>"
            });
            break;
        case 403:
            Message.error('登录已过期');
            localStorage.removeItem("role");
            localStorage.removeItem("user");
            sessionStorage.removeItem("lcSteps");
            sessionStorage.removeItem("xmmc");
            localStorage.removeItem("tbtsnr");
            localStorage.removeItem("jgdm");
            sessionStorage.removeItem("bdId");
            sessionStorage.removeItem("kbxmZt");
            sessionStorage.removeItem("searchObj");
            sessionStorage.removeItem("myParam");
            sessionStorage.removeItem("currentSectionId");
            window.location.href = '/login'
            break;
        case 404:
            Message.error('请求的资源不存在');
            break;
        case 500:
            Message.error(other?.msg || '未知错误');
            break;
        default:
    }

}



//设置axios实例
var instance = axios.create({
    /*  transformRequest: [function (data) {
         //对data进行转换处理
         return JSON.stringify(data)
     }], */
    timeout: 30000 * 2, //请求超时时间
    withCredentials: true,//跨域请求时是否需要使用凭证
});
//设置post请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
/*
*请求拦截器
*每次请求前。如果存在token责在请求头里携带token
 */
let str = ['/api/v2/kb/kbxmdcbj/kqzcbj', '/api/v2/kb/kbxmdcbj/dcbjquery', '/api/v2/kb/kbxmdcbj/ispublish'];
instance.interceptors.request.use(
    config => {
        //登录流程控制中，根据本地是否存在token判断用户的登录情况
        //即使存在token，也可能过期了，所以每次请求的时候带上token
        //后台根据携带的token判断用户的登录情况，并返回对应的状态码
        //而后我们可以在响应拦截器中，根据状态码进行一些统一的操作
        if (str.includes(config.url)) {
            config.headers['contentType'] = 'application/x-www-form-urlencoded';
        }
        const currentSectionId = sessionStorage.getItem("currentSectionId");
        if (currentSectionId) {
            config.headers['sectionId'] = currentSectionId;
        }
        const xmdl = sessionStorage.getItem("xmdl");
        if (xmdl) {
            config.headers['xmdl'] = xmdl;
        }
        return config;
    },
    error => Promise.error(error)
)
//响应拦截器
instance.interceptors.response.use(
    //请求成功
    res => {
        // 401
        if (res && res.data && res.data.meta && res.data.meta.code == 401) {
            errorMsg(401)
            return
        }
        if (res.status === 200) {
            return Promise.resolve(res)
        } else {
            errorMsg(res.status)
            return Promise.reject(res)
        }
    },
    //请求失败
    error => {
        const { response } = error;
        if (response) {
            //请求已发出，但是不在2**的范围
            errorMsg(response.status,)
            return Promise.reject(response);
        } else {
            //处理断网的情况
            //eg:请求超时或断网时，更新state的network状态
            //network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
            //关于断网组件中的刷新重新获取数据，会在断网组件中说明
            //           store.commit('changeNetwork',false)
        }
    }
)

export default instance;
